import md5 from 'js-md5';
import axios from 'axios'

var util={
    _http:axios,
    //公共参数
    carsParam:function(data,isPost, isWenZhang){
        let commParam = {
            timestamp: Math.round(new Date().getTime() / 1000),
            version: 'v1',
            format: 'json',
            app_key: isWenZhang ? 'VC728xOw1yDgEXwaWI3ORlccemOj5hqy' : 'FskE9a4EVMs6HbkbB0Mi8X5iBi',
    //      callback: jsonpStr?'jsonp'+jsonpStr:'jsonp',
            nonce:new Date().getMilliseconds()+"0"+Math.floor(Math.random()*10000),
        };
        if(!data){
            data={};
        }
        let newParam = util.extend(data,commParam );
        
        let sortParm = util.objKeySort(newParam);
        let row_sign = '';
        let sign = '';
        for (let i in sortParm) {
                if(i != "callback"){
                        row_sign += i + '=' + sortParm[i] + '&'
                }
        }
        
        row_sign += isWenZhang ? 'qFWmkeSj9MtkraQAwcOqnc2XcFXtyoWwBPfZhaibDACUDBhBNs7dIDAWKn1CRG1l':'n9rXl1S3UpM5gagRfuxJ5q9kqvpLYw8oz9T4gyHAlrKPA';
        
        sign = md5(row_sign);
        commParam.sign = sign;
        
        let finalParam ;
    // let finalParam = extend({}, commParam, data.params);
        

        if (isPost=="post") {
        finalParam = commParam
        } else {
            finalParam = Object.assign(data, commParam);
        }

        let urldata=''
        for(let val in finalParam){
                urldata +=  val+"="+finalParam[val]+"&";
        }

            finalParam = urldata.substring(0, urldata.lastIndexOf("&"));

        return finalParam;
           
    },
    extend:function(target, options) {
        for (name in options) {
            target[name] = options[name];
        }
        return target;
    },
    //排序的函数
    objKeySort:function(obj){
        let newkey = Object.keys(obj).sort();
        let newObj = {};
        for (let i = 0; i < newkey.length; i++) {
            newObj[newkey[i]] = obj[newkey[i]];
        }
        return newObj;
    },
    setCookie(name,value,day){
        let Days = day;
        let exp = new Date();
        exp.setTime(exp.getTime() + Days*24*60*60*1000);
        document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
    },
    getCookie(name){
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg)){
            return unescape(arr[2]);
        }else{
            return null;
        }
    },
    clickLog(data){
        util._http.post("/accountCenter/v2/user/click-log?" + util.carsParam({}, "post"),
            {
            mobile_sys: data.mobile_sys,
            mobile_data:data.mobile_data,
            click_type:data.click_type
            }
        )
    },
    iosOrAndroid(){
        let u = navigator.userAgent, app = navigator.appVersion;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1||u.indexOf('Adr') > -1; 
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
        if (isAndroid) {
            return "android"
        }else if (isIOS) {
            return "ios"
        }else{
            return "pc"
        }
    },
    getMobileBrand(){
        let ua = navigator.userAgent.split("(")[1].split(")")[0];
        let brand = "";
        let phone = [/IPHONE/gi, /huawei/gi, /mi/gi, /vivo/gi, /OPPO/gi, /samsung/gi, /SONY/gi, /Nokia/gi, /HTC/gi, /ZTE/gi, /Lenovo/gi, /ZUK/gi,]
        if (phone[0].test(ua)) {
            brand = "iPhone";
        } else if (phone[1].test(ua)) {
            brand = "HUAWEI";
        } else if (phone[2].test(ua)) {
            brand = "小米";
        } else if (phone[3].test(ua)) {
            brand = "vivo";
        } else if (phone[4].test(ua)) {
            brand = "OPPO";
        } else if (phone[5].test(ua)) {
            brand = "SAMSUNG";
        } else if (phone[6].test(ua)) {
            brand = "SONY";
        } else if (phone[7].test(ua)) {
            brand = "Nokia";
        } else if (phone[8].test(ua)) {
            brand = "HTC";
        } else if (phone[9].test(ua)) {
            brand = "ZTE";
        } else if (phone[10].test(ua) || phone[11].test(ua)) {
            brand = "Lenovo";
        } else {
            brand = "未知型号";
        }
        return brand;
    }

}

export default util;